export default "__VITE_ASSET__j$j21URS__"